export { default } from './modal';
export { default as modalConfig } from './modal.config';
